import { useTranslation } from 'react-i18next';
import { useAsset } from '@/utils/asset';

export default function PressBar() {
    const { t } = useTranslation();
    const asset = useAsset();

    const logos = [
        { key: 'welt', src: asset('logos/welt-logo-gray.png'), href: 'https://unternehmen.welt.de/finanzen-immobilien/kostenloses-mietkautionskonto.html' },
        { key: 'fr', src: asset('logos/fr-logo-gray.png'), href: 'https://partner.fr.de/mietkautionskonto-kosten.html' }
    ];

    return (
        <section aria-label={t('home.pressBar.label')} className="border-y border-gray-200 bg-white dark:border-white/5 dark:bg-gray-950">
            <div className="mx-auto max-w-7xl px-6 py-8 lg:px-8">
                <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-center sm:gap-8">
                    <p className="shrink-0 text-base uppercase font-semibold tracking-wider dark:text-gray-400 text-gray-500">
                        {t('home.pressBar.label')}
                    </p>
                    <div aria-hidden="true" className="hidden h-4 w-px bg-gray-200 sm:block dark:bg-white/10" />
                    <ul className="flex list-none items-center justify-center gap-10 sm:gap-14" role="list">
                        {logos.map((logo) => (
                            <li key={logo.key}>
                                <a href={logo.href} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={logo.src}
                                        alt={t(`home.pressBar.logos.${logo.key}`)}
                                        className="h-9 w-auto object-contain opacity-70 grayscale transition-opacity duration-200 hover:opacity-100 dark:invert dark:opacity-90 dark:hover:opacity-60"
                                        loading="lazy"
                                        decoding="async"
                                        height={36}
                                    />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
